/* v4 PDP sticky bar - scroll visibility + form sync (femininebalance fb-pdp-sticky-bar parity) */
(function () {
  'use strict';

  var section = document.querySelector('.v4-pdp');
  var form = document.getElementById('bal-pdp-form');
  var bar = document.getElementById('v4-pdp-sticky-bar');
  if (!section || !form || !bar) return;

  /* Escape section stacking contexts so the popup stays above below-fold bands. */
  if (bar.parentElement !== document.body) {
    document.body.appendChild(bar);
  }

  var qtyInput = document.getElementById('v4-pdp-quantity');
  var qtyDisplay = bar.querySelector('.v4-pdp-sticky-bar__qty-val');
  var priceEl = bar.querySelector('.v4-pdp-sticky-bar__price');
  var purchaseTypeEl = bar.querySelector('.v4-pdp-sticky-bar__purchase-type');
  var stickyCta = document.getElementById('v4-pdp-sticky-cta');
  var mainCta = form.querySelector('[data-pdp-atc]');

  function getQty() {
    return Math.max(1, Number(qtyInput && qtyInput.value) || 1);
  }

  function unitPriceFromActiveTile() {
    var priceNode = section.querySelector('.v4-pdp__purchase-tile.--active .v4-pdp__purchase-price');
    if (!priceNode) return '';
    var nodes = priceNode.childNodes;
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.nodeType === Node.TEXT_NODE && node.textContent.trim()) {
        return node.textContent.trim();
      }
    }
    return priceNode.textContent.replace(/\s*\/\s*bottle\s*/i, '').trim();
  }

  function purchaseLabelFromActiveTile() {
    var labelNode = section.querySelector('.v4-pdp__purchase-tile.--active .v4-pdp__purchase-label');
    return labelNode ? labelNode.textContent.trim() : '';
  }

  function syncStickyPricing() {
    var unitPrice = unitPriceFromActiveTile();
    var purchaseLabel = purchaseLabelFromActiveTile();
    if (purchaseTypeEl && purchaseLabel) {
      purchaseTypeEl.textContent = purchaseLabel;
    }
    if (priceEl && unitPrice) {
      priceEl.textContent = unitPrice;
    }
    if (stickyCta && mainCta) {
      var label = (mainCta.textContent || '').trim();
      /* D09 (2026-08-21): the sticky label is REBUILT from the main CTA on every
         price/variant sync, so whatever separator this line writes is what the
         live DOM ends up with - regardless of how clean the served HTML was.
         Normalise every dash form to the middot the served markup uses. */
      stickyCta.textContent = label.replace(/^Add to Cart\s*[-\u2010-\u2015\u00b7]\s*/i, 'Add to Cart \u00b7 ');
      var aria = mainCta.getAttribute('aria-label');
      if (aria) {
        stickyCta.setAttribute('aria-label', aria.replace(/\s[-\u2010-\u2015]\s/, ' \u00b7 '));
      }
      stickyCta.disabled = !!mainCta.disabled;
    }
  }

  function setQty(next) {
    var val = Math.max(1, Math.min(99, next));
    if (qtyInput) qtyInput.value = String(val);
    if (qtyDisplay) qtyDisplay.textContent = String(val);
  }

  document.addEventListener('v4:purchase-changed', syncStickyPricing);

  if (mainCta && typeof MutationObserver !== 'undefined') {
    new MutationObserver(syncStickyPricing).observe(mainCta, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled'],
    });
  }

  bar.querySelectorAll('[data-qty-delta]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      setQty(getQty() + Number(btn.getAttribute('data-qty-delta') || 0));
    });
  });

  if (stickyCta) {
    stickyCta.addEventListener('click', function () {
      if (mainCta && (mainCta.disabled || mainCta.getAttribute('aria-disabled') === 'true')) return;
      form.requestSubmit();
    });
  }

  var visibilityFrame = 0;

  function isMainCtaOnScreen() {
    if (!mainCta) return true;
    var rect = mainCta.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh && rect.bottom > 0;
  }

  function hasScrolledPastMainCta() {
    if (!mainCta) return false;
    return mainCta.getBoundingClientRect().bottom <= 0;
  }

  function setBarVisible(show) {
    bar.classList.toggle('--visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    document.documentElement.classList.toggle('v4-pdp-sticky-bar-open', show);
    if (stickyCta) stickyCta.tabIndex = show ? 0 : -1;
  }

  function updateBarVisibility() {
    visibilityFrame = 0;
    /* Only emerge after the hero ATC has left the top of the viewport — not
       when it sits below the fold on first paint (IO false-positive). */
    var show = !isMainCtaOnScreen() && hasScrolledPastMainCta();
    setBarVisible(show);
  }

  function scheduleBarVisibilityUpdate() {
    if (visibilityFrame) return;
    visibilityFrame = window.requestAnimationFrame(updateBarVisibility);
  }

  window.addEventListener('scroll', scheduleBarVisibilityUpdate, { passive: true });
  window.addEventListener('resize', scheduleBarVisibilityUpdate, { passive: true });
  updateBarVisibility();

  syncStickyPricing();
  window.addEventListener('load', syncStickyPricing);
  requestAnimationFrame(syncStickyPricing);
})();
